import templateUrl from "emun.salesrep/territory-manager/region/region-prompt.htm";
import RegionPromptController from "emun.salesrep/territory-manager/region/region-prompt.controller";
import modals from "webmodals/modals";

const resolve = () => null;
const reject = reason => console.warn('reject reason', reason);

const RegionPrompt = {
  open(options) {
    const prom = modals.open(Object.assign({
      size: 'lg quick-report-prompt',
      templateUrl,
      resolve: {
        options: () => options
      },
      bindToController: true,
		controller: RegionPromptController,
      controllerAs: '$ctrl'
    }, (options || {}).modal)).result;

    prom.then(resolve, reject);

    return prom;
  }
};

export default RegionPrompt;
